import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = "404 - Page Not Found | AMX Ventures";
    const desc = "This page doesn't exist. Return to AMX Ventures homepage to explore our portfolio, blog insights on ecosystem-led growth, and hyperscaler partnership strategies.";
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);

    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="flex min-h-[80vh] items-center justify-center px-4">
        <div className="text-center space-y-6">
          <h1 className="text-9xl font-black text-accent">404</h1>
          <p className="text-3xl font-bold text-foreground">Page Not Found</p>
          <p className="text-xl text-muted-foreground max-w-md">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Button size="lg" className="mt-8 font-bold" asChild>
            <a href="/">Return to Home</a>
          </Button>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
